import {Component, OnInit} from '@angular/core';
import {PaginationObject} from '../pagination-object';
import {SubmissionHistoryService} from '../../../shared/services/submission-history.service';
import { SampleSearchObject } from '../search-object';
import {DateUtil} from '../date-util';

@Component({
    selector: 'samplepagination',
    templateUrl: './pagination.component.html'
})
export class SamplePaginationComponent implements OnInit {

    constructor(private submissionHistoryService: SubmissionHistoryService) {}

    pagination : PaginationObject = new PaginationObject()

    searchCriteria: SampleSearchObject = new SampleSearchObject()

    ngOnInit() {
        this.submissionHistoryService.currentSamplePagination.subscribe(message => this.pagination = message);
        this.submissionHistoryService.currentSampleSearchCriteria.subscribe(message => this.searchCriteria = message);
    }

    selectPage(page: any) {
        this.pagination.pageSize = page.pageSize;
        this.pagination.currentPage = page.pageIndex;
        this.submissionHistoryService.updateSamplePagination(this.pagination.totalCount);
        if (this.searchCriteria != null) {
            let startDate = this.searchCriteria.startDate == null ? '' : DateUtil.formatDate(this.searchCriteria.startDate);
            let endDate = this.searchCriteria.endDate == null ? '' : DateUtil.formatDate(this.searchCriteria.endDate);
            this.submissionHistoryService.getSampleSearchTableContent(this.searchCriteria, startDate, endDate, this.pagination.currentPage);
        } else {
            this.submissionHistoryService.getSessionTableContent();
        }
        $('#dashboardScrollPane').scrollTop(0);
    }
}
